export const SECTIONS = [
  {
    name: 'sections',
    items: ['routes', 'projects', 'draft-projects', 'layers', 'projects-layer']
  },
  {
    name: 'parametricTables',
    items: ['priorizaciones', 'disclaimers', 'etapas', 'alcances', 'estados-estudios', 'estados', 'financiadores-estudios', 'paises', 'sectores', 'subsectores', 'tipos-proyecto', 'metrics', 'metric-values']
  },
  {
    name: 'administration',
    items: ['users']
  }
];
